import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ALL_DAY_LABEL, FULL_DAY_NAME_BY_VALUE, INPUT_DATE_FORMAT } from './constants';
import DateUtils from '../../../utils/date/DateUtils';
import { capitalize } from '../../../utils/strings';
export function formatDay() {
  var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$fullDayName = _ref.fullDayName,
    fullDayName = _ref$fullDayName === void 0 ? false : _ref$fullDayName;
  function formatSingleDay() {
    var singleDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var formattedDay = singleDay;
    if (formattedDay.includes('_')) {
      var _formattedDay$split = formattedDay.split('_');
      var _formattedDay$split2 = _slicedToArray(_formattedDay$split, 2);
      formattedDay = _formattedDay$split2[1];
    }
    if (fullDayName) {
      formattedDay = FULL_DAY_NAME_BY_VALUE[formattedDay.toUpperCase()];
    }
    return capitalize(formattedDay);
  }
  if (day.includes(',')) {
    // multiple days case
    var days = day.split(',');
    return "".concat(formatSingleDay(days[0]), " - ").concat(formatSingleDay(days[days.length - 1]));
  }
  return formatSingleDay(day);
}
function parseTime() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$format = _ref2.format,
    format = _ref2$format === void 0 ? INPUT_DATE_FORMAT : _ref2$format;
  var date = DateUtils.parse(time, format);
  var minutes = +date.getMinutes();
  if (minutes > 0) {
    return DateUtils.format(date, 'h:mma').toLowerCase();
  }
  return DateUtils.format(date, 'ha').toLowerCase();
}
export function formatTime() {
  var openTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var closeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (openTime === closeTime) {
    return ALL_DAY_LABEL;
  }
  return "".concat(parseTime(openTime), " - ").concat(parseTime(closeTime));
}